/**
 * Asking for the sign-in dialog from anywhere on the page.
 *
 * `AuthLauncher` owns the AuthModal but is rendered by the outer `App()`, a SIBLING of the editor
 * (`AppInner`) — so a caller inside the editor, such as the chop error banner's "Sign in", cannot
 * reach it by props without threading state through a component that has no other use for it.
 * A window event keeps the two decoupled and works wherever the asker happens to sit.
 */
export const REQUEST_SIGN_IN_EVENT = 'imageslicer:request-sign-in';

/** Ask the launcher to open the sign-in dialog. No-op if nothing is listening. */
export function requestSignIn(): void {
  try {
    window.dispatchEvent(new CustomEvent(REQUEST_SIGN_IN_EVENT));
  } catch (_e) {
    // A browser without CustomEvent simply gets no dialog; the message still tells them to sign in.
  }
}

/**
 * Asking for the My Account dialog, for the same reason: the asker (AuthContext, after a sign-in
 * that turned out to have nothing to buy) cannot reach the launcher by props.
 */
export const REQUEST_ACCOUNT_EVENT = 'imageslicer:request-account';

/** Why the dialog was opened for them, when it was not their own click. */
export type AccountNotice = 'already-pro';

export function requestAccount(notice?: AccountNotice): void {
  try {
    window.dispatchEvent(new CustomEvent(REQUEST_ACCOUNT_EVENT, { detail: { notice } }));
  } catch (_e) {
    // No dialog; they are signed in and still on the page they were on.
  }
}
